import { Header, Page } from 'redesign';
import { useTranslation } from 'react-i18next';
import { PartnerFilterToolbox } from './components/partner-filter-toolbox/partner-filter-toolbox';
import { PARTNERS_FILTER_INITIAL_VALUE } from './partners.types';
import { PartnersList } from './partners-list';
import { useExternalParams } from '../../../../shared/hooks';

const Partners = () => {
  const [params, setParams] = useExternalParams(PARTNERS_FILTER_INITIAL_VALUE);
  const { t } = useTranslation('hq-screen-specific');

  return (
    <Page
      header={<Header titleText={t('sidebar.partners')} />}
      toolbox={<PartnerFilterToolbox params={params} setParams={setParams} />}
    >
      <PartnersList params={params} />
    </Page>
  );
};

export { Partners };
